import makeStyles from '@mui/styles/makeStyles'
import { alpha } from '@mui/material/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    zIndex: 1010,
    borderRadius: '0.5rem',
    width: 'calc(100% - 1rem)',
    height: 'calc(100% - 2rem)',
    padding: '0.5rem'
  },

  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    border: `2px dashed ${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: '16px',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    backgroundColor: alpha(theme.palette.secondary.main, 0.5)
  },

  contentCenter: {
    alignItems: 'center'
  },

  contentOver: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main
  },

  text: {
    paddingTop: '25%',
    color: 'black',
    fontSize: theme.size.lg
  },

  textCenter: {
    paddingTop: '0'
  }
}))

export default useStyles
